/* CheckBoxEditor.js */

"use strict";

const CommonEditor = require("./CommonEditor");

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
const InputCheckboxControl = uiCore.Control.Boolean.InputCheckbox;

class CheckBoxEditor extends CommonEditor {
    constructor(options) {
        super(options);
        const item = options.item;
        this._timeOut;
        this._onMouseleave = this._onMouseleave.bind(this);
        this._onMouseenter = this._onMouseenter.bind(this);
        if (item.title) {
            const root = this.input.renderer.getRootElement();
            // console.log(root);
            switch (item.newrole) {
                case "some-selected":
                    root.classList.add("varied-checked");
                    break;
                case "all-selected":
                    root.classList.add("checked");
                    break;
                case "none-selected":
                    root.classList.remove("checked", "varied-checked");
                    break;
            }
            this._registerInstanceListeners();
        }
    }

    _createInput() {
        return new InputCheckboxControl({
            darkTheme: true,
        });
    }

    _registerInstanceListeners() {
        this.rootElement.addEventListener("mouseleave", this._onMouseleave);
        this.rootElement.addEventListener("mouseenter", this._onMouseenter);
    }

    _unregisterInstanceListeners() {
        this.rootElement.removeEventListener("mouseenter", this._onMouseenter);
        this.rootElement.removeEventListener("mouseleave", this._onMouseleave);
    }

    loadValue(item) {
        let fieldValue = item[this._fieldName];
        if (item.title) {
            switch (fieldValue) {
                case "some-selected":
                    fieldValue = undefined;
                    break;
                case "all-selected":
                    fieldValue = true;
                    break;
                case "none-selected":
                    fieldValue = false;
                    break;
            }
        }
        this.initialData = fieldValue;
        if (this.input) {
            this.input.setValue(fieldValue);
        }
    }

    applyValue(item, state) {
        // console.log(state);
        let cbval = state;
        if (this._itemData.title) {
            if (state) {
                cbval = "all-selected";
            } else {
                cbval = "none-selected";
            }
        }
        item[this._fieldName] = cbval;
    }

    destroy() {
        this._unregisterInstanceListeners();
        super.destroy();
    }

    /*****************************/
    /*  PUBLIC API IS INHERITED  */
    /*****************************/

    _onMouseleave() {
        this._timeOut = setTimeout(() => {
            if (this && this.rootElement) {
                this.commitChanges();
            }
        }, 2000);
    }

    _onMouseenter() {
        window.clearInterval(this._timeOut);
    }
}

module.exports = CheckBoxEditor;
